import type { FrontModule } from "@nabble/sdk";
import { lazy } from "react";

const AuditPage = lazy(() => import("./pages/AuditPage/AuditPage"));
const LogsPage = lazy(() => import("./pages/LogsPage/LogsPage"));

export const observabilityModule: FrontModule = {
  id: "observability",
  version: "0.1.0",
  permission: "observability.audit.read",
  label: "Observability",
  icon: "activity",
  description: "See who did what in the suite and how the platform is running.",
  routes: [
    { path: "/observability/audit", Component: AuditPage },
    { path: "/observability/logs", Component: LogsPage },
  ],
  menu: [
    {
      id: "observability.audit",
      label: "Audit",
      icon: "shield",
      path: "/observability/audit",
      permission: "observability.audit.read",
      description: "Who did what, when and from where.",
    },
    {
      id: "observability.logs",
      label: "Logs",
      icon: "terminal",
      path: "/observability/logs",
      permission: "observability.logs.read",
      description: "Technical records from the platform to help diagnose problems.",
    },
  ],
};

export default observabilityModule;
